export default "__VITE_ASSET__ZlE1B8Ts__"